import { getLogger } from "@hoteltradergit/ht-telemetry-ui-lib";

export const DEFAULT_FILTER_VALUES = {
  selectedFilters: {
    ratePlans: ["all"],
    roomTypes: ["all"],
    mealPlans: ["all"],
    promotions: ["all"],
    refundableOptions: ["all"],
  },
  filterSelectionOrder: [],
};

export const persistFilterValues = (selectedFilters, filterSelectionOrder) => {
  // Persist the latest filter values for future sessions
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      const filterData = {
        selectedFilters,
        filterSelectionOrder,
        timestamp: Date.now(),
      };
      window.localStorage.setItem(
        "priceCheckFilterValues",
        JSON.stringify(filterData)
      );
    } catch (error) {
      // ignore storage write errors (e.g., quota, privacy mode)
      getLogger().error("PriceCheckFilterUtils", {
        type: "Error",
        page_url: window.location.href,
        error_desc: "Error persisting filter values",
        error_stack: error?.stack ?? null,
      });
    }
  }
};

// Helper function to load and parse stored filter values
const loadStoredFilterValues = () => {
  const raw = window.localStorage.getItem("priceCheckFilterValues");
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);

    // Check if the stored data is recent (within 24 hours)
    const isRecent =
      parsed.timestamp && Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000;

    if (!isRecent) {
      // Clear old data
      window.localStorage.removeItem("priceCheckFilterValues");
      return null;
    }

    return {
      selectedFilters:
        parsed.selectedFilters || DEFAULT_FILTER_VALUES.selectedFilters,
      filterSelectionOrder:
        parsed.filterSelectionOrder ||
        DEFAULT_FILTER_VALUES.filterSelectionOrder,
    };
  } catch (error) {
    getLogger().error("PriceCheckFilterUtils", {
      type: "Error",
      page_url: window.location.href,
      error_desc: "Error parsing stored filter values",
      error_stack: error?.stack ?? null,
    });
    return null;
  }
};

// Initialize filter values from localStorage
export const getInitialFilterValues = () => {
  if (typeof window === "undefined" || !window.localStorage) {
    return DEFAULT_FILTER_VALUES;
  }

  try {
    const storedValues = loadStoredFilterValues();
    if (storedValues) {
      return storedValues;
    }

    // No stored values found, persist defaults
    persistFilterValues(
      DEFAULT_FILTER_VALUES.selectedFilters,
      DEFAULT_FILTER_VALUES.filterSelectionOrder
    );
    return DEFAULT_FILTER_VALUES;
  } catch (error) {
    getLogger().error("PriceCheckFilterUtils", {
      type: "Error",
      page_url: window.location.href,
      error_desc: "Error loading filter values",
      error_stack: error?.stack ?? null,
    });
    return DEFAULT_FILTER_VALUES;
  }
};

// Clear stored filter values
export const clearStoredFilterValues = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    try {
      window.localStorage.removeItem("priceCheckFilterValues");
    } catch (error) {
      getLogger().error("PriceCheckFilterUtils", {
        type: "Error",
        page_url: window.location.href,
        error_desc: "Error clearing filter values",
        error_stack: error?.stack ?? null,
      });
    }
  }
};
